import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    
      },
    // this is the spot to modify
    
      theme: {
        themes: {
          light: {
             primary: '#2699FB',
            //primary: '#ff3399',
             background: '#ef5777',
            //background: '#ff3399',
            black: '#3d3e3e',
            filled: 'f0f0f0',
            labelgrey: '#757575',
            fontgrey: '#BDBDBD',
            
          },
          dark: {
            primary: '#FFFFFF',
            error: '#2699FB'
          }
        }
      }
    })
